import { z } from 'zod';
import { CaseIdSchema, IsoTimestampSchema } from './common.js';

export const CaseStatusSchema = z.enum(['active', 'archived', 'closed']);
export type CaseStatus = z.infer<typeof CaseStatusSchema>;

export const CaseSchema = z.object({
  id: CaseIdSchema,
  navn: z.string().min(1, 'Saksnavn kan ikke være tomt'),
  saksnummer: z.string().min(1, 'Saksnummer kan ikke være tomt'),
  klient: z.string().min(1, 'Klient kan ikke være tomt'),
  status: CaseStatusSchema,
  createdAt: IsoTimestampSchema,
  updatedAt: IsoTimestampSchema,
});

export type Case = z.infer<typeof CaseSchema>;
